import React, { useEffect, useState } from 'react'

import outcomeMockup from '../../../assets/images/medilearn/medilearnoutcome.webp'

// SCREEN IMAGES
import screen1 from '../../../assets/images/medilearn/outcomescreen1.webp'
import screen2 from '../../../assets/images/medilearn/outcomescreen2.webp'
import screen3 from '../../../assets/images/medilearn/outcomescreen3.webp'
import screen4 from '../../../assets/images/medilearn/outcomescreen4.webp'

const screens = [screen1, screen2, screen3, screen4]

const OutcomeMedilearn = () => {
  const [activeScreen, setActiveScreen] = useState(0)

  // useEffect(() => {
  //   const interval = setInterval(() => {                                                  
  //     setActiveScreen((prev) => (prev + 1) % screens.length)
  //   }, 2500)

  //   return () => clearInterval(interval)
  // }, [])

  return (
    <section className="relative overflow-hidden py-5 md:py-20">

      {/* LEFT GLOW */}
      <div
        className="pointer-events-none absolute left-0 top-[60%] md:top-[55%] lg:top-[50%] xl:top-[55%] 2xl:top-[55%] z-0 h-[100px] md:h-[150px] lg:h-[250px] w-[200px] md:w-[300px] lg:w-[500px] -translate-y-1/2"
        style={{
          background:
            'radial-gradient(82.96% 47.27% at 0.26% 49.19%, #D4FF76 30%, rgba(212,255,118,0) 100%)',
        }}
      />

      {/* RIGHT GLOW */}
      <div
        className="pointer-events-none absolute right-0 top-[70%] md:top-[65%] lg:top-[65%] xl:top-[65%] 2xl:top-[65%] z-0 h-[100px] md:h-[150px] lg:h-[250px] w-[200px] md:w-[300px] lg:w-[500px] -translate-y-1/2"
        style={{
          background:
            'radial-gradient(82.96% 47.27% at 0.26% 49.19%, #D4FF76 30%, rgba(212,255,118,0) 100%)',
          transform: 'translate(0%, -50%) scaleX(-1)',
        }}
      />

      <div className="mx-auto max-w-[1800px] px-5">

        {/* HEADING */}
        <div className="relative mx-auto flex justify-center">

          {/* CIRCLE BORDER */}
          <div
            className="
              absolute z-20
              md:top-[-40px]
              lg:top-[-40px]
              xl:top-[-50px]
              2xl:top-[-80px]
              h-[220px]
              w-[220px]
              rounded-full
              md:h-[320px]
              md:w-[320px]
              lg:h-[320px]
              lg:w-[320px]
              xl:h-[300px]
              xl:w-[300px]
              2xl:h-[500px]
              2xl:w-[500px]
            "
            style={{
              padding: '7px',
              background:
                'linear-gradient(180deg, rgb(255, 255, 255) 0%, rgba(255,255,255,0.28) 32%, rgba(255,255,255,0.06) 100%)',
              WebkitMask:
                'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              WebkitMaskComposite: 'xor',
              maskComposite: 'exclude',
            }}
          />

          {/* TITLE */}
          <div className="relative top-[30px] z-30 flex items-center gap-2 md:gap-5 bg-[#9BB069] px-8">

            <div className="h-1.5 w-1.5 rounded-full bg-white md:h-3 md:w-3" />

            <h2 className="font-gilroy-extrabold text-xl uppercase text-black md:text-3xl 2xl:text-5xl">
              Outcome
            </h2>

            <div className="h-1.5 w-1.5 rounded-full bg-white md:h-3 md:w-3" />

          </div>

        </div>

        {/* MOCKUP */}
        <div className="relative z-20 mt-10 flex justify-center">

          <div
            className="
              relative
              w-full
              md:w-[450px]
              lg:w-[520px]
              xl:w-[650px]
              2xl:w-[850px]
            "
          >

            {/* SCREEN IMAGE */}
            <div
              className="
                absolute
                left-[51.3%]
                top-[4.3%]
                z-10
                h-[95.2%]
                w-[330px]
                -translate-x-1/2
                overflow-hidden
                rounded-[12px]
                md:rounded-[18px]
                lg:rounded-[22px]
                xl:rounded-[24px]
                2xl:rounded-[26px]
              "
            >

              {screens.map((screen, index) => (
                <img
                  key={index}
                  src={screen}
                  alt=""
                  className={`
                    absolute inset-0 h-full w-full object-cover
                    transition-all duration-[1200ms] ease-in-out
                    ${
                      activeScreen === index
                        ? 'opacity-100 scale-100'
                        : 'opacity-0 scale-105'
                    }
                  `}
                />
              ))}

            </div>

            {/* MOCKUP IMAGE */}
            <img
              src={outcomeMockup}
              alt=""
              className="relative z-20 w-full object-contain"
            />

          </div>

        </div>

      </div>

    </section>
  )
}

export default OutcomeMedilearn